import Controller from '../abstracts/Controller';
import 'scss-templates/t-privacy.scss';

export default class PrivacyLoginController extends Controller {
  static get COMPONENTS() {
    return [
      'PrivacyProfilingComponent',
      'DatePickerComponent'
    ];
  }
}
